<ng-container [ngSwitch]="renderLink()">
  <a
    *ngSwitchCase="'externalLink'"
    class="link focus-link"
    rdOpenInNewTab
    [attr.href]="path"
    [attr.aria-label]="ariaLabel">
    <ng-container *ngTemplateOutlet="linkText"></ng-container>
    <ng-container *ngTemplateOutlet="newWindowIcon"></ng-container>
  </a>

  <a
    *ngSwitchCase="'internalLink'"
    class="link focus-link"
    [routerLink]="[path]"
    [attr.aria-label]="ariaLabel">
    <ng-container *ngTemplateOutlet="linkText"></ng-container>
  </a>

  <button *ngSwitchCase="'buttonLink'" class="button-reset link focus-link">
    <ng-container *ngTemplateOutlet="linkText"></ng-container>
  </button>
</ng-container>

<ng-template #linkText>
  <span class="link-text" [ngClass]="contentClass">{{ text }}</span>
</ng-template>

<ng-template #newWindowIcon>
  <rd-shared-icon
    *ngIf="shouldDisplayLinkIcon"
    class="dialog-opener-arrow-icon ml-2 mt-1 h-3 w-3"
    [iconSymbol]="linkIcon"
    [iconTheme]="'link'"></rd-shared-icon>
</ng-template>
